import { useEffect } from 'react';
import { AppRouter } from './app/router';
import { useAuthStore } from './shared/store/auth';

export function App(): JSX.Element {
  const markHydrated = useAuthStore((s) => s.markHydrated);

  // Fail-safe: sessionStorage es síncrono así que para cuando llegamos al
  // primer render el snapshot ya está disponible. Forzamos isHydrated=true
  // en el siguiente tick por si onRehydrateStorage no se ejecutó (escenarios
  // de SSR/hot-reload).
  useEffect(() => {
    markHydrated();
  }, [markHydrated]);

  return <AppRouter />;
}
